'use strict';

var TYPES = ['T01', 'T02', 'T03', 'T04', 'T05', 'T06', 'T07', 'T08', 'T09', 'T10', 'T11'];
var DEFAULT_TYPE = 'T02';

module.exports = {
    TYPES: TYPES,
    DEFAULT_TYPE: DEFAULT_TYPE
};


// WEBPACK FOOTER //
// ./~/wix-base-ui/lib/controls/textTypes.js